import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable component to display a single course option row in mat-select dropdown
 * Reduces duplication of course option display logic (appears 2+ times in template)
 * Shows course name with "NEW" tag if it's the highlighted/newly-added option
 */
@Component({
  selector: 'app-course-option-row',
  templateUrl: './course-option-row.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class CourseOptionRowComponent {
  @Input() courseOption: string = '';
  @Input() highlightedCourseOption: string | null = null;
}
